import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaymentState {
    multiplePayment: Record<string, any>;
}

const initialState: PaymentState = {
    multiplePayment: {},
};

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setDataMultiplePayment: (state, action: PayloadAction<Record<string, any>>) => {
            state.multiplePayment = action.payload;
        },
    },
});

export const { setDataMultiplePayment } = paymentSlice.actions;
export default paymentSlice.reducer;
